
import { Component, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/auth";
import { EventLoginRequest } from "@/store/auth/types";

@Component({})
export default class Login extends Vue {
  public dialog = false;
  public eventInfo = {};
  public MeetingID = "";
  public MeetingCode = "";
  public error = "";
  public async Login(): Promise<void> {
    const payload: EventLoginRequest = {
      MeetingCode: this.MeetingCode,
      MeetingID: parseInt(this.MeetingID),
    };
    await AuthModule.EventLogin(payload);

    const currentSuccessStatus = AuthModule.currentEventToken;

    if (currentSuccessStatus) {
      this.dialog = true;
      this.eventInfo = AuthModule.currentEventInfo;
      console.log(this.eventInfo);
    } else {
      const currentErrorMessage = AuthModule.currentError;
      if (currentErrorMessage) {
        this.$notify({
          group: "tickets",
          type: "error",
          title: "Event Login",
          text: `Login is unsuccessful! ${currentErrorMessage}`,
        });
      } else {
        this.$router.push({ path: "/Expired", query: { id: this.MeetingID, code: this.MeetingCode } });
      }
    }
  }
  public windowValidation(): void {
    this.$notify({
      group: "tickets",
      type: "success",
      title: "Event Login",
      text: "Login is successful!",
    });
    this.$router.push("/QRScanner");
  }

  public windowCancel(): void {
    AuthModule.LogoutUser();
    window.localStorage.clear();
    window.location.reload();
  }
}
